var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogo = function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 40 41"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#logo_svg__a)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    x: 4,
    y: 1,
    fill: "#2A2A2A",
    rx: 8
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M17.172 8c-1.016 0-1.99.403-2.708 1.121L11 12.586v1.586c0 1.12.481 2.128 1.248 2.828A3.82 3.82 0 0 0 11 19.828v1.586l3.464 3.465A3.83 3.83 0 0 0 20 24.752a3.828 3.828 0 0 0 5.535.127L29 21.414v-1.586c0-1.12-.481-2.128-1.248-2.828A3.82 3.82 0 0 0 29 14.172v-1.586L25.535 9.12A3.83 3.83 0 0 0 20 9.248 3.82 3.82 0 0 0 17.172 8m5.42 9a4 4 0 0 1-.127-.121L20 14.414l-2.465 2.465a4 4 0 0 1-.127.121q.066.06.127.121L20 19.586l2.465-2.465q.061-.062.127-.121M21 21.414v.758a1.828 1.828 0 0 0 3.121 1.293L27 20.585v-.757a1.828 1.828 0 0 0-3.121-1.293zm-2 0-2.879-2.879A1.828 1.828 0 0 0 13 19.829v.758l2.879 2.879A1.828 1.828 0 0 0 19 22.172zm0-9.586v.758l-2.879 2.878A1.828 1.828 0 0 1 13 14.173v-.758l2.879-2.878A1.828 1.828 0 0 1 19 11.828m4.879 3.637L21 12.584v-.757a1.828 1.828 0 0 1 3.121-1.292L27 13.414v.758a1.828 1.828 0 0 1-3.121 1.292",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "logo_svg__a",
    width: 40,
    height: 41,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    operator: "dilate",
    radius: 1,
    result: "effect1_dropShadow_0_39"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.137255 0 0 0 0 0.137255 0 0 0 0 0.137255 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_39"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.0596454 0 0 0 0 0.0596454 0 0 0 0 0.0596454 0 0 0 0.24 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_0_39",
    result: "effect2_dropShadow_0_39"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_0_39",
    result: "shape"
  })))));
};
export default SvgLogo;